import React from 'react'

interface Props {
  message: string
}

const DomainInactive = ({ message }: Props) => {
  return (
    <div className="min-h-screen w-full flex flex-col items-center justify-center gap-4 px-6 text-center bg-white">
      <h1 className="text-2xl font-semibold text-error-red">Domain unavailable</h1>
      <p className="max-w-md text-base text-secondary-darkGray">{message}</p>
    </div>
  )
}

export default DomainInactive
